/**
 * Connects `app/errors.ts` (which runs outside React — the query client is built before the
 * first render) to the one toast host of F4 §7.7. Mount it once, inside `UiProvider`.
 *
 * P-011: without this, a refused mutation reaches `window` and the person sees nothing.
 */
import { useEffect } from 'react';
import { useToast } from '@elizmonday/ui';
import { handleUnauthenticated } from '../lib/trpc';
import { setErrorSink } from './errors';

export function ErrorToastBridge(): null {
  const toast = useToast();

  useEffect(() => {
    return setErrorSink((report) => {
      toast(report.message, { kind: 'negative' });
      /*
       * A session that ended is not something a toast can fix. `handleUnauthenticated` keeps
       * the current route in `?next=` and does nothing on a public path — the `/__ui` fixtures
       * and the auth screens run with no session on purpose, and there the toast is the whole
       * answer.
       */
      if (report.code === 'UNAUTHORIZED') {
        handleUnauthenticated(window.location.pathname, window.location.search);
      }
    });
  }, [toast]);

  return null;
}
